
import React, { Component } from "react";

import BsyDashboardMenu from '../BsyDashboardMenu'
import BsyDashboardContent from '../BsyDashboardContent'

import { BsyUtils } from '../../../utils/Utils';
import './index.css';
import { withRouter } from "react-router-dom";

class BsyDashboardUserApp extends Component {

    constructor(props) {
        super(props)
        this.state = {
            routePath: "/team/app/:appid",
            appsCache: [],
            success: !1,
            appid: window.FX.STATIC.APPID,
            type: '',
            entryid: '',
            groupid: '',
            apps: [],
            dashboardMode: 'dashboard', //工作台模式 dashboard 工作台  xxxxx 应用访问界面 allapp 全部应用界面
            components: [],
        }
    }

    selectApp = (appinfo) => {
        this.dashborderMenuContext.selectApp(appinfo)
    }

    onAllApp = () => {
        this.setState({
            dashboardMode: 'allapp',
            appid: 'allapp',
            appsCache: this._getCache(this.state.apps)
        })
    }

    getDashborderMenuContext = (context) => {
        this.dashborderMenuContext = context;
    }

    getDashborderContentContext = (context) => {
        this.dashborderContentContext = context;
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const { appid, type, entryid, groupid } = nextProps.match.params;
        this.setState({
            appid: appid,
            type: type,
            routePath: nextProps.match.path,
            entryid: entryid,
            groupid: groupid,
            appsCache: this._getCache(this.state.apps)
        })

    }

    componentDidMount = () => {
        const { routePath } = this.state;
        if (routePath == '/') {
            let key = "_appID_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
            if (BsyUtils.Store.get(key)) {


                let cache = BsyUtils.Store.get(key)[window.FX.STATIC.corpId];

                if (cache && cache.selectAppid) {
                    if (cache[cache.selectAppid]) {
                        if (!cache.user_id) {
                            let obj = cache[cache.selectAppid]
                            if (obj.appid && obj.type && obj.entryid) {
                                this.props.history.push(`${window.rootDirectroy}/team/app/${obj.appid}/${obj.type}/${obj.entryid}`)
                            } else {
                                this.props.history.push(window.rootDirectroy + "/team/app/" + obj.appid)
                            }
                        }

                    }
                }
            }
        }
        this.applist();
    }

    applist = () => {
        React.axios('/dashboard/app_group/list').then(async res => {
            this.appMap = null;
          
            let apps = this._getCache(res.data.dock_items ? [...res.data.items, ...res.data.dock_items] : [...res.data.items,])
            this.setState({
                appsCache: apps,
                success: !0,
                dockItem: res.data.dock_items ? [...res.data.dock_items] : [],
                dockCorp: res.data.dock_items ? [...res.data.dock_corps] : [],
                apps: [...res.data.items],
            })
        }).catch(res => {
            console.error(res);
        })
    }

    //查询app是否存在
    _findAppCache = (items, appId) => {
        if (!this.appMap) {
            this.appMap = {};
            items.map((data, index) => {
                data.apps.map((data1, index) => {
                    this.appMap[data1._id] = data;
                })
            })
        }
        return !!this.appMap[appId];

    }

    _getCache = (items) => {
        var key = "_applist_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
        let apps = BsyUtils.Store.get(key) || [];
        if (BsyUtils.isObjectEmpty(apps)) {
            key = "_applist_" + window.FX.STATIC.corpId;
            apps = BsyUtils.Store.get(key) || [];
        }
        let appsCache = [];
        apps.map((data, index) => {
            if (this._findAppCache(items, data._id)) {
                appsCache.push(data);
            }
        })
        return appsCache;
    }

    save = (components) => {
        this.setState({
            dashboardMode: 'dashboard',
            appid: 'dashboard',
            entryid: '',
            type: '',
            groupid: '',
            components: components,
        })
    }



    render() {
        const { appsCache, appid, entryid, type, groupid, routePath, apps, dashboardMode, components, success } = this.state;
        return (
            <div className={'bsy-dashboard ' + window.mode}>
                {success && <>
                    <BsyDashboardMenu
                        getContext={this.getDashborderMenuContext}
                        appsCache={appsCache}
                        hasDesign={true}
                        apps={apps}
                        appid={appid}
                        entryid={entryid}
                        type={type}
                        routePath={routePath}
                        onAllApp={this.onAllApp}
                        onSave={this.save}
                        components={components}
                    />
                    <BsyDashboardContent
                        getContext={this.getDashborderContentContext}
                        appid={appid}
                        entryid={entryid}
                        type={type}
                        apps={apps}
                        groupid={groupid}
                        routePath={routePath}
                        dashboardMode={dashboardMode}
                        components={components}
                    />
                </>}
            </div>
        )
    }
}

export default withRouter(BsyDashboardUserApp)